import React, { useEffect, useState } from "react";
import HeaderImageSection from "../shared/headerImageSection";
import FooterComponent from "../footerComponent/footerComponent";
import Header from "../header/header";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { Button, FormControl, TextField } from "@mui/material";
import "./login.scss";
import { useNavigate } from "react-router";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { API_URL } from "../../variables";
import useRecaptchaV3 from "../reCaptcha";

const Login = () => {
  const [loginInfo, setLoginInfo] = useState({
    username: "",
    password: "",
  });
  const [loginBtnClicked, setLoginBtnClicked] = useState(false);
  // const [token, setToken] = useState("");
  // const executeRecaptcha = useRecaptchaV3(
  //   "6LfqONQqAAAAAOc_EPmZ9ezdK8fgnBsM57U2XZqV",
  //   "login"
  // );
  const [submitEnabled, setSubmitEnabled] = useState(true);
  const [message, setMessage] = useState("");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  //useEffect(() => {
  //   if (token.length) {
  //     setSubmitEnabled(true);
  //   }
  // }, [token]);

  // const handleToken = (token) => {
  //   setToken(token);
  // };

  const callLoginAPI = async () => {
    if (!(loginInfo.username === "" || loginInfo.password === "")) {
     // const recaptchaToken = await executeRecaptcha('login');
      let obj = {
        username: loginInfo.username,
        password: loginInfo.password,
        //token: recaptchaToken,
      };
      axios
        .post(API_URL + "login", obj)
        .then(function (res) {
          if (res.data.body.includes("Login successful")) {
            localStorage.setItem("userLoggedIn", "Yes");
            localStorage.setItem("image_uploaded", res.data.image_uploaded);
            localStorage.setItem("member_id", res.data.member_id);
            localStorage.setItem("member_status", res.data.status);
            navigate("/myProfile");
          }
        })
        .catch(function (error) {
          console.log("error..........", error);
          if (error.status === 401 || error.status === 404) {
            toast.error("Username or password incorrect, please try again.", {
              position: "top-center",
              autoClose: 7000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        });
    }
  };
  let navigate = useNavigate();
  return (
    <>
      <ToastContainer />
      <Header />
      <HeaderImageSection />
      <section className="p-4 sectionContainer bg-white mt-4">
        <div className="row">
          <div className="col-sm-8 p-3 accordianDetails mb-4">
            <label className="headerLabel">Login</label>
            <div className="row">
              <div className="col-sm-6 mb-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">Username :</label>
                  <TextField
                    error={loginBtnClicked && loginInfo.username === ""}
                    size="small"
                    variant="outlined"
                    placeholder="Enter username"
                    value={loginInfo.username}
                    onChange={(event) => {
                      setLoginInfo((prev) => ({
                        ...prev,
                        username: event.target.value,
                      }));
                    }}
                  />
                  {/* <span className="infoText d-block mt-1">
                    (E.g: MB12346, MG12347, MBD12348, MGD12349)
                  </span> */}
                  {loginBtnClicked && loginInfo.username === "" && (
                    <span className="requiredText">Required</span>
                  )}
                </FormControl>
              </div>
              <div className="col-sm-6 mb-4">
                <FormControl variant="standard" className="w-100">
                  <label className="inputFieldLabel">Password :</label>
                  <TextField
                    error={loginBtnClicked && loginInfo.password === ""}
                    size="small"
                    variant="outlined"
                    type="password"
                    placeholder="Enter password"
                    value={loginInfo.password}
                    onChange={(event) => {
                      setLoginInfo((prev) => ({
                        ...prev,
                        password: event.target.value,
                      }));
                    }}
                  />
                  {/* <span className="infoText d-block mt-1">
                    (Eg- lorem@gmail.com / 8888336245)
                  </span> */}
                  {loginBtnClicked && loginInfo.password === "" && (
                    <span className="requiredText">Required</span>
                  )}
                </FormControl>
              </div>
            </div>
            {/* <div>
              <ReCaptcha siteKey={"6LfqONQqAAAAAOc_EPmZ9ezdK8fgnBsM57U2XZqV"} callback={handleToken}/>
            </div> */}
            <div className="text-right">
              <Button
                size="large"
                variant="contained"
                className={`${
                  submitEnabled
                    ? "buttonClass loginScreenBtn"
                    : "bg-gray-600 cursor-not-allowed"
                } `}
                // className="buttonClass loginScreenBtn"
                onClick={() => {
                  setLoginBtnClicked(true);
                  callLoginAPI();
                }}
                // onClick={handleSubmit}
                disabled={!submitEnabled}
              >
                Login
              </Button>
            </div>
            {/* <div className="mt-5">
              <div className="text-center">
                <span className="captchaContainer">8787</span>
              </div>
              <div className="mt-3 mb-3 d-flex flex-col fullWidthInPhone">
                <label className="w-25 textDarkRed fullWidthInPhone shadow-none">
                  Please Enter Above Verification Code / कृपया वर सत्यापन कोड
                  प्रविष्ट करा
                </label>
                <div className="pr-2">
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Enter the above code"
                    className="w-100"
                  />
                  <label className="font12px textDarkRed">
                    * Please enter verification code then click Login.
                  </label>
                </div>
                <div>
                  <Button
                    size="large"
                    variant="contained"
                    className="buttonClass loginScreenBtn"
                    onClick={() => {
                      setLoginBtnClicked(true);
                      navigate("/myProfile");
                      callLoginAPI();
                    }}
                  >
                    Login
                  </Button>
                </div>
              </div>
            </div> */}
          </div>
          <div className="col-sm-4">
            <label className="textDarkRed">
              For more Information Kindly go through the below help videos or
              contact us
            </label>
            <div className="p-2 mb-3">
              <div className="videoContainerImg d-flex align-items-center justify-content-center ">
                <PlayCircleIcon className="playIcon" />
              </div>
              <label className="textDarkRed">How to login</label>
            </div>
            <div className="p-2 mb-3">
              <div className="videoContainerImg d-flex align-items-center justify-content-center ">
                <PlayCircleIcon className="playIcon" />
              </div>
              <label className="textDarkRed">How to register yourself</label>
            </div>
          </div>
        </div>
      </section>
      <FooterComponent />
    </>
  );
};
export default Login;

// import React, { useState } from "react";
// import axios from "axios";

// const Login = () => {
//   const [formData, setFormData] = useState({
//     first_name: "",
//     full_name: "",
//     dob: "",
//     mobile_no: "",
//   });

//   const [files, setFiles] = useState({
//     image1: null,
//     image2: null,
//     adhar: null,
//     bio_data: null,
//   });

//   const handleInputChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleFileChange = (e) => {
//   const file = e.target.files[0];
//   if (file && file.size > 50 * 1024 * 1024) { // 50 MB limit
//     alert("File size exceeds 50 MB limit. Please upload a smaller file.");
//     return;
//   }
//   setFiles({
//     ...files,
//     [e.target.name]: file,
//   });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Create a FormData object to send data and files
//     const data = new FormData();

//     // Append form fields
//     for (const key in formData) {
//       data.append(key, formData[key]);
//     }

//     // Append files
//     for (const key in files) {
//       if (files[key]) {
//         data.append(key, files[key]);
//       }
//     }

//     try {
//       const response = await axios.post("http://localhost:8000/addmember", data, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       alert("Member added successfully!");
//       console.log(response.data);
//     } catch (error) {
//       console.error("Error adding member:", error.response?.data || error.message);
//       alert("Failed to add member.");
//     }
//   };

//   const data = formData;

// const formDataObj = new FormData();

// // Add JSON data
// formDataObj.append("data", JSON.stringify(data));

// // Add files
// formDataObj.append("image1", files.image1);
// formDataObj.append("image2", files.image2);
// formDataObj.append("adhar", files.adhar);
// formDataObj.append("bio_data", files.bio_data);

//   return (
//     <div>
//       <h2>Add Member</h2>
//       <form onSubmit={handleSubmit}>
//         <div>
//           <label>First Name:</label>
//           <input
//             type="text"
//             name="first_name"
//             value={formData.first_name}
//             onChange={handleInputChange}
//             required
//           />
//         </div>
//         <div>
//           <label>Full Name:</label>
//           <input
//             type="text"
//             name="full_name"
//             value={formData.full_name}
//             onChange={handleInputChange}
//             required
//           />
//         </div>
//         <div>
//           <label>Date of Birth:</label>
//           <input
//             type="date"
//             name="dob"
//             value={formData.dob}
//             onChange={handleInputChange}
//             required
//           />
//         </div>
//         <div>
//           <label>Mobile Number:</label>
//           <input
//             type="text"
//             name="mobile_no"
//             value={formData.mobile_no}
//             onChange={handleInputChange}
//             required
//           />
//         </div>
//         <div>
//           <label>Image 1:</label>
//           <input
//             type="file"
//             name="image1"
//             accept="image/*"
//             onChange={handleFileChange}
//             required
//           />
//         </div>
//         <div>
//           <label>Image 2:</label>
//           <input
//             type="file"
//             name="image2"
//             accept="image/*"
//             onChange={handleFileChange}
//             required
//           />
//         </div>
//         <div>
//           <label>Aadhar Document:</label>
//           <input
//             type="file"
//             name="adhar"
//             accept=".pdf"
//             onChange={handleFileChange}
//             required
//           />
//         </div>
//         <div>
//           <label>Bio-data Document:</label>
//           <input
//             type="file"
//             name="bio_data"
//             accept=".doc,.docx,.pdf"
//             onChange={handleFileChange}
//             required
//           />
//         </div>
//         <button type="submit">Add Member</button>
//       </form>
//     </div>
//   );
// };

// export default Login;
